<script setup>
import { ref, computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import AgentStickersAPI from 'dashboard/api/agentStickers';
import Button from 'next/button/Button.vue';

const props = defineProps({
  attachmentId: {
    type: Number,
    required: true,
  },
});

const { t } = useI18n();
const isSaving = ref(false);
const isSaved = ref(false);

const buttonTitle = computed(() =>
  isSaved.value
    ? t('CONVERSATION.REPLYBOX.STICKERS.SAVED')
    : t('CONVERSATION.REPLYBOX.STICKERS.SAVE_RECEIVED')
);

const saveAsSticker = async () => {
  if (isSaving.value || isSaved.value) return;

  try {
    isSaving.value = true;
    await AgentStickersAPI.createFromAttachment(props.attachmentId);
    isSaved.value = true;
    useAlert(t('CONVERSATION.REPLYBOX.STICKERS.SAVE_SUCCESS'));
  } catch (error) {
    useAlert(t('CONVERSATION.REPLYBOX.STICKERS.SAVE_ERROR'));
  } finally {
    isSaving.value = false;
  }
};
</script>

<template>
  <Button
    xs
    solid
    slate
    :icon="isSaved ? 'i-lucide-check' : 'i-ph-sticker'"
    class="opacity-60"
    :title="buttonTitle"
    :aria-label="buttonTitle"
    :is-loading="isSaving"
    :disabled="isSaving || isSaved"
    @click.stop="saveAsSticker"
  />
</template>
